/**
 * Picks v2 or v1 of the Captions Review Queue page based on the
 * redesign flag.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import CaptionsReviewQueuePage   from './CaptionsReviewQueuePage';
import CaptionsReviewQueuePageV2 from './CaptionsReviewQueuePageV2';

export default function CaptionsReviewQueuePageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? CaptionsReviewQueuePageV2 : CaptionsReviewQueuePage;
  return <Component {...props} />;
}
